/*
 * Lightweight Performance-Instrumentierung fuer Sync-Hotpaths.
 *
 * Aktivierung zur Laufzeit in der Browser-Konsole:
 *   window.__SYNC_PERF__ = true
 *
 * Deaktivierung:
 *   window.__SYNC_PERF__ = false
 *
 * Bei false (oder undefined) ist der Overhead praktisch null — measure() gibt
 * das Ergebnis der uebergebenen Funktion unveraendert zurueck und ruft weder
 * performance.now() noch console.log auf.
 */

/**
 * Misst die Laufzeit einer async-Operation und loggt bei aktivem Flag.
 *
 * @param {string} label    Kurzer Bezeichner der Operation (z.B. 'flush.versions')
 * @param {() => Promise<any>} fn  Die zu messende Funktion
 * @param {(result: any) => number} [countFn]  Optional: extrahiert eine
 *     Record-Count aus dem Ergebnis zum Mitloggen (z.B. `r => r.length`)
 * @returns Das Ergebnis von fn()
 */
export async function measure(label, fn, countFn) {
    if (typeof window === 'undefined' || !window.__SYNC_PERF__) {
        return fn()
    }
    const t0 = performance.now()
    const result = await fn()
    const dt = performance.now() - t0
    const count = countFn ? countFn(result) : null
    const countStr = count !== null ? `${count} records, ` : ''
    console.log(`[sync-perf] ${label}: ${countStr}${dt.toFixed(1)} ms`)
    return result
}

/**
 * Zeit-Checkpoint innerhalb eines laengeren Ablaufs (nicht-async).
 * Gibt eine End-Funktion zurueck, die die verstrichene Zeit loggt.
 *
 *   const end = mark('syncProject.total')
 *   ... Arbeit ...
 *   end()
 */
export function mark(label) {
    if (typeof window === 'undefined' || !window.__SYNC_PERF__) {
        return () => {}
    }
    const t0 = performance.now()
    return (extra) => {
        const dt = performance.now() - t0
        const suffix = extra ? ` (${extra})` : ''
        console.log(`[sync-perf] ${label}: ${dt.toFixed(1)} ms${suffix}`)
    }
}
